/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SharedHotelLocalizedCurrencyAmount
 */
export interface SharedHotelLocalizedCurrencyAmount {
  /**
   *
   * @type {number}
   * @memberof SharedHotelLocalizedCurrencyAmount
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof SharedHotelLocalizedCurrencyAmount
   */
  currency: string;
}

/**
 * Check if a given object implements the SharedHotelLocalizedCurrencyAmount interface.
 */
export function instanceOfSharedHotelLocalizedCurrencyAmount(
  value: object
): value is SharedHotelLocalizedCurrencyAmount {
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  return true;
}

export function SharedHotelLocalizedCurrencyAmountFromJSON(
  json: any
): SharedHotelLocalizedCurrencyAmount {
  return SharedHotelLocalizedCurrencyAmountFromJSONTyped(json, false);
}

export function SharedHotelLocalizedCurrencyAmountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelLocalizedCurrencyAmount {
  if (json == null) {
    return json;
  }
  return {
    value: json["value"],
    currency: json["currency"],
  };
}

export function SharedHotelLocalizedCurrencyAmountToJSON(
  json: any
): SharedHotelLocalizedCurrencyAmount {
  return SharedHotelLocalizedCurrencyAmountToJSONTyped(json, false);
}

export function SharedHotelLocalizedCurrencyAmountToJSONTyped(
  value?: SharedHotelLocalizedCurrencyAmount | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
    currency: value["currency"],
  };
}
